import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '../interfaces/api-response.model';
import { API_ENDPOINTS } from '../constants/api.constants';
import { DownloadUserPlanRequest, DownloadUserPlanResponse } from '../interfaces/download-userPlan.model';

@Injectable({
  providedIn: 'root',
})
export class DownloadUserPlanService {
  http: HttpClient = inject(HttpClient);

  /**
   * 下載個人化方案比較表 (CB-045)
   * @param request 
   */
  downloadUserPlan(
    request: DownloadUserPlanRequest
  ): Observable<HttpResponse<Blob>> {
    return this.http.post(
      API_ENDPOINTS.DOWNLOAD_USER_PLAN,
      request,
      {
        responseType: 'blob',
        observe: 'response'
      }
    );
  }
}
